<app-header />
<p-toast></p-toast>

<div class="home-main">
  <div class="sidebar">
    <app-sidebar
      (headingEvent)="receiveHeading($event)"
      (toggleSidebarEvent)="receiveSidebarEvent($event)"
    />
  </div>
  <div
    class="main-container"
    [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'"
  >
    <nav class="breadcrumb">
      <a href="/">Home</a>
      <i class="pi pi-angle-right"></i>
      <a (click)="goBack()">Back to Search</a>
      <i class="pi pi-angle-right"></i>

      <ng-container
        *ngFor="let breadcrumb of breadcrumbItems; let last = last"
      >
        <a
          [routerLink]="breadcrumb.url"
          (click)="onBreadcrumbClick(breadcrumb.url)"
          [class.active]="last"
          style="cursor: pointer; text-decoration: none"
        >
          {{ breadcrumb.label }}
        </a>
        <span *ngIf="!last">&gt;</span>
      </ng-container>
      <span>{{ searchQueryGrid }}</span>
      <div
        style="margin-left: auto; display: flex; align-items: center; gap: 20px"
      >
        <button
          class="route-label"
          (click)="openPdfPlatformsDialog()"
          *ngIf="privilege_json?.Download"
        >
          Download PDF
        </button>
        <button class="raise-query-btn2" (click)="showRaiseQuery()">
          Raise Query
        </button>
      </div>
    </nav>
    <hr />
    <div
      class="modal fade bg_4"
      id="raise_query_modal"
      tabindex="-1"
      aria-labelledby="sign_in"
      aria-hidden="true"
    >
      <div class="modal-dialog text-center modal-dialog-centered">
        <div class="modal-content p-x-15 bg_1">
          <div class="dis-block-2">
            <div class="p-top-32">
              <span class="text_blue_9">Raise Query</span>
            </div>
          </div>
          <div class="modal-body">
            <form
              [formGroup]="form_RaiseQuery"
              (submit)="submitRaiseQueryForm()"
            >
              <div class="mb-3">
                <label for="user_email" class="form-label dis-flex-4 text_grey_2"
                  >Response Email</label
                >
                <input
                  type="text"
                  class="form-control text_grey_3"
                  id="user_email"
                  formControlName="txtResponseEmail"
                  placeholder="Enter Email ID / User ID"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label dis-flex-4 text_grey_2"
                  >Comments</label
                >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  formControlName="txtQuery"
                  placeholder="Enter Your Comments"
                ></textarea>
              </div>
              <div class="input-group mb-3">
                <input
                  type="file"
                  #fileInput
                  class="form-control"
                  id="inputGroupFile01"
                  (change)="onFileSelected($event)"
                />
              </div>
              <div class="mb-3 text_start color_black font_14">
                <span class="weight_700">Your Search Query:</span>
                <p class="weight_500">{{ searchQueryGrid }}</p>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  margin-bottom: 1rem;
                "
              >
                <button
                  type="submit"
                  class="button_blue_6 text_white_1 p-3 mx-2"
                >
                  Submit
                </button>
              </div>
            </form>
            <div class="color_black font_14 weight_500 text_start mb-3">
              ChemRobotics Team is happy to serve you! Your query will be
              answered soon.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-bottom: 10px;
      "
    >
      <ng-container *ngIf="accountType === 'premium'">
        <img
          src="../../../assets/img/premium.png"
          alt="user type"
          height="25"
          style="max-width: 80px"
        />
      </ng-container>
      <ng-container *ngIf="accountType === 'free'">
        <img
          src="../../../assets/img/evaluation-version.png"
          alt="user type"
          height="25"
          style="max-width: 80px"
        />
      </ng-container>
    </div>

    <div class="container">
      <!-- Title Section -->
      <div class="title-section">
        <div class="title-button-wrapper">
          <img
            src="../../../assets/img/AgropatLogo3.png"
            alt=""
            style="margin-top: 20px"
          />
          <!-- <button class="download-btn" (click)="exportToPDF()">
              <i class="icon-pdf"></i> Download as PDF
            </button> -->
        </div>
        <p class="subtitle">
          AgroPat Ultimate is basically designed for scientist and product
          development team including regulatory or registration, IP (patent)
          professionals etc., wherein entire product Landscape can be accessed
          with all essential documents.
        </p>
      </div>
    </div>
    <div class="tab-container">
      <!-- Left Scroll Button -->
      <button class="tab-button" (click)="scrollTabs('left')">&#8592;</button>

      <!-- Scrollable Tab Content -->
      <div #scrollContainer class="tab-content">
        <div
          *ngFor="let tab of tabs; let i = index"
          class="tab-item"
          [ngClass]="{ selected: selectedTab === i }"
          (click)="changeTab(i, tab.functionName)"
        >
          {{ tab.label }}
        </div>
      </div>

      <!-- Right Scroll Button -->
      <button class="tab-button" (click)="scrollTabs('right')">&#8594;</button>
    </div>

    <!-- Pdf platform dialog -->
    <p-dialog
      header="Generate Pdfs"
      [modal]="true"
      [(visible)]="pdfPlatformDialog"
      [style]="{ width: '25rem' }"
    >
      <div style="display: flex; flex-direction: column; gap: 14px">
        <div
          style="display: flex; gap: 10px"
          *ngFor="let platform of pdfPlatforms"
        >
          <input
            type="checkbox"
            style="height: 20px; width: 20px"
            [(ngModel)]="platform.isSelected"
          />
          <p style="font-size: 15px">{{ platform.platformLable }}</p>
        </div>
      </div>

      <p-footer>
        <button class="btn btn-sm btn-primary" (click)="generatePdf()">
          Generate
        </button>
      </p-footer>
    </p-dialog>

    <div class="content-outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-footer />
